import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, responsivefy} from '../functions'

export default function (chart, divId, vizName) {
    console.warn(vizName)
    axios({url: '/json/forcenwthout.json', baseURL: '', method: 'GET'}).then(res => {
        let graph = res.data

        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append("svg")
            .attr("width", chart.width)
            .attr("height", chart.height)
            .call(responsivefy)

        var metric1ColorScale = d3.scaleOrdinal(d3.schemeCategory10);

        var simulation = d3.forceSimulation()
            .force("link", d3.forceLink().id(function (d) {
                return d.id;
            })
                .distance(80))
            .force("charge", d3.forceManyBody())
            .force("center", d3.forceCenter(chart.width / 3, chart.height / 3.5));

        var link = svg.append("g")
            .attr("class", "links")
            .selectAll("line")
            .data(graph.links)
            .enter().append("line")
            .attr("stroke-width", function (d) {
                return Math.sqrt(d.value / 10);
            })
            .attr("stroke", "#999")
            .attr("stroke-opacity", "0.6")
            .on("mouseover", function (d, i) {
                console.warn(d, ":", i)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);

                div.html("<span style='color:black'>" +
                    "Basket Item" + colonAnnotation + d.source.id + "<br>" +
                    "Reco Item" + colonAnnotation + d.target.id + "<br>" +
                    "Margin_lift" + colonAnnotation + d.value + "<br>" +
                    "</span>"
                )
                    .style("left", (d3.event.pageX + 42) + "px")
                    .style("top", (d3.event.pageY - 58) + "px");
            })
            .on("mouseout", function () {
                div.transition().duration(500).style("opacity", 0);
            });

        var div = d3.select("body")
            .data(graph.links)
            .append("div")
            .attr("class", "speech-bubble")

        var node = svg.append("g")
            .selectAll("g")
            .data(graph.nodes)
            .enter()
            .append("g")

        var circles = node.append("circle")
            .attr("fill", function (d) {
                return metric1ColorScale(d.row);
            })
            .data(graph.links)
            .attr("r", function (d) {
                return Math.sqrt(d.value * 2);
            })
            .data(graph.nodes)
            .attr("stroke", "#fff")
            .attr("stroke-width", "1.5px")
            .call(d3.drag()
                .on("start", dragstarted)
                .on("drag", dragged)
                .on("end", dragended))

        console.warn(circles)

        node.append("title").data(graph.nodes).text(function (d) {
            return d.id
        })

        var lables = node.append("text")
            .attr("font-size", "12px")
            .text(function (d) {
                if (d.id.length > 6)
                    return d.id.substring(0, 5) + '...'
                else
                    return d.id
            })
            .attr('x', 6)
            .attr('y', 3);

        console.warn(lables)

        simulation.nodes(graph.nodes).on("tick", ticked);
        simulation.force("link").links(graph.links);

        function ticked() {
            link.attr("x1", function (d) {
                return d.source.x;
            })
                .attr("y1", function (d) {
                    return d.source.y;
                })
                .attr("x2", function (d) {
                    return d.target.x;
                })
                .attr("y2", function (d) {
                    return d.target.y;
                });

            node.attr("transform", function (d) {
                return "translate(" + d.x + "," + d.y + ")";
            })
        }

        function dragstarted(d) {
            if (!d3.event.active) simulation.alphaTarget(0.3).restart();
            d.fx = d.x;
            d.fy = d.y;
        }

        function dragged(d) {
            d.fx = d3.event.x;
            d.fy = d3.event.y;
        }

        function dragended(d) {
            if (!d3.event.active) simulation.alphaTarget(0);
            d.fx = null;
            d.fy = null;
        }
    });
}
